import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const locationApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLocations: builder.query({
      query: filters => {
        const qs = Object.keys(filters).reduce((acc, k) => {
          acc.set(k, filters[k]);
          return acc;
        }, new URLSearchParams());
        return `location/?${qs}`;
      },
      providesTags: ['Location'],
    }),
    createLocation: builder.mutation({
      query: body => ({
        url: 'location/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['Location'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {useGetLocationsQuery, useCreateLocationMutation} = locationApi;
